module.exports = __webpack_public_path__ + "static/img/twxcode.071c878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/twxcode.png
// module id = 6ozt
// module chunks = 0